import React from 'react'
import { useField, useFormikContext } from 'formik'
import { format, parse } from 'date-fns';

import BaseDateTimePicker from 'react-widgets/DatePicker'
import Localization from 'react-widgets/Localization'
import { DateLocalizer } from 'react-widgets/IntlLocalizer';

import { FieldWrapper } from './FieldWrapper'
import { InputDefaults, inputClasses } from './form-defaults';

import 'react-widgets/styles.css';

function formatDate(date: Date) {
  return format(date, "yyyy-MM-dd");
}

const guessDateTime = (rawValue: string) => {
  const matches = rawValue.match(/([0-9]+)\/([0-9]+)\/([0-9]+)\, ([0-9]+):([0-9]+)(:[0-9]+)?/)?.map(v => parseInt(v, 10))
  // Ritorna una data non valida che restituisce NaN con getTime
  if (!matches || matches.length != 7) return new Date('October 35, 1996 12:35:32');

  const [_, day, month, year, hour, minutes, seconds] = matches;
  let guess = new Date()
  guess.setDate(day);
  guess.setMonth(month - 1)
  guess.setFullYear(2000 + year);
  guess.setHours(hour);
  guess.setMinutes(minutes)
  if (!isNaN(seconds)) {
    guess.setSeconds(seconds);
  } else {
    guess.setSeconds(0);
  }
  return guess
}


interface DateTimeProps extends InputDefaults<Date> {
  locale?: string,
}

const FormikDateInput = ({
  name,
  label,
  helpText,
  disabled = false,
  readOnly = false,
  wrapped = true,
  locale = "it-IT",
  time
}: DateTimeProps & { time: boolean }) => {
  const [field, meta] = useField(name)
  const { setFieldValue } = useFormikContext();

  const timestamp = Date.parse(field.value);

  const formatter: (d: Date) => string = time ?
    d => d.toISOString()
    : d => formatDate(d)
  const setvalue = (date: Date | null | undefined, rawValue: string) => {
    if (!!date) {
      setFieldValue(name, formatter(date))
    } else {
      const guess = guessDateTime(rawValue);
      if (!isNaN(guess.getTime())) {
        setFieldValue(name, formatter(guess))
      } else {
        console.warn("Data invalida, raw value", rawValue, guess);
      }
    }
  }

  if (isNaN(timestamp)) {
    setvalue(new Date(), new Date().toISOString())
  }

  return (
    <FieldWrapper
      name={name}
      label={label}
      helpText={helpText}
      error={meta.touched && meta.error ? meta.error : undefined}
      wrapped={wrapped}
    >
      <Localization
        date={new DateLocalizer({ culture: locale })}
      >
        <BaseDateTimePicker
          value={new Date(field.value)}
          disabled={disabled}
          readOnly={readOnly}
          onChange={setvalue}
          messages={{ dateButton: "Data" }}
          includeTime={time}
          timePrecision="seconds"
          valueDisplayFormat={{ dateTimeStyle: "medium" }}
        />
      </Localization>
    </FieldWrapper>
  )
}

export const DatePicker = (props: DateTimeProps) => <FormikDateInput time={false} {...props} />;
export const DateTimePicker = (props: DateTimeProps) => <FormikDateInput time={true} {...props} />;
